var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart2Warp"},[_vm._m(0),_c('data-filter',{staticStyle:{"right":"0px"},attrs:{"filterOption":_vm.timeRanges},on:{"change":_vm.changeTimeRange}}),_c('pie-chart',{attrs:{"width":300,"seriesData":_vm.seriesData,"legendData":_vm.legendData,"subtext":_vm.subtext}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lineChart__title"},[_c('span'),_vm._v(" 一级分类下载占比 ")])
}]

export { render, staticRenderFns }